import { render, staticRenderFns } from "./abnormalDialog.vue?vue&type=template&id=966fe648"
import script from "./abnormalDialog.vue?vue&type=script&lang=js"
export * from "./abnormalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports